export const P0003600DureeAjustementLoiEau = [
  { ref: +5, label: '+5' },
  { ref: +4, label: '+4' },
  { ref: +3, label: '+3' },
  { ref: +2, label: '+2' },
  { ref: +1, label: '+1' },
  { ref: 0, label: '0' },
  { ref: -1, label: '-1' },
  { ref: -2, label: '-2' },
  { ref: -3, label: '-3' },
  { ref: -4, label: '-4' },
  { ref: -5, label: '-5' },
];
